import { createAction, props } from '@ngrx/store';
import { SelfServiceableAccounts, SelfServiceableAccountsPayload } from '../models/accounts.model';

export const loadAccounts = createAction('[Accounts] Load Accounts');
export const loadAccountsSuccess = createAction('[Accounts] Load Accounts Success', props<{ data: SelfServiceableAccountsPayload}>());
export const loadAccountsError = createAction('[Accounts] Load Accounts Error', props<{ error: any}>());
export const updateAccountsWithCasData = createAction('[Accounts] Update Accounts With CAS Data', props<{data: SelfServiceableAccounts}>());
export const clearAccounts = createAction('[Accounts] Clear Accounts');